<script setup lang="ts">
/** The 22px search field of a card toolbar. Full width on a phone. */
withDefaults(defineProps<{ placeholder?: string; modelValue?: string }>(), { placeholder: 'Search…', modelValue: '' })
const emit = defineEmits<{ 'update:modelValue': [v: string] }>()
const onInput = (event: Event) => emit('update:modelValue', (event.target as HTMLInputElement).value)
</script>

<template>
  <input
:value="modelValue" :placeholder="placeholder" type="search"
    class="hit h-[var(--toolbar-control-height)] w-[var(--measure-14p2857rem)] rounded-[var(--radius-compact)] border border-border bg-muted/50 px-[var(--measure-7px)] text-xs placeholder:text-muted-foreground focus:border-primary/60 focus:outline-none max-md:w-full"
    @input="onInput">
</template>
